import _get from 'lodash/get'
import { baseRequest } from '.'

export const getInfluencerReferrersData = async id => {
  const res = await baseRequest.get(`/events/${id}/relationships/referrals/`)
  return _get(res, 'data.data', {})
}

export const brandsReferralsCheckToken = async token => {
  const res = await baseRequest.post(`brands/referrals/check?token=${token}`)
  return _get(res, 'data.data')
}

export const brandsReferralsUpdateToken = async (token, customer_id, brand_id) => {
  const res = await baseRequest.post(`brands/referrals/update?token=${token}`, {
    data: {
      attributes: {
        customer_id,
        brand_id,
      },
    },
  })
  return _get(res, 'data.data')
}